import React from 'react';
import { motion } from 'framer-motion';
import { ProgressIndicator } from './ProgressIndicator';
import { ArrowLeftIcon } from 'lucide-react';
export function QuizSlide({
  questionNum,
  totalQuestions,
  headline,
  options,
  onSelect,
  onBack,
  onSkip
}: {
  questionNum: number;
  totalQuestions: number;
  headline: string;
  options: string[];
  onSelect: (index: number) => void;
  onBack: () => void;
  onSkip: () => void;
}) {
  return <div className="flex flex-col h-full px-6 py-12 relative z-10 bg-[#0B1623]" data-id="element-119">
      {/* Lab background with heavy dark overlay */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-120">
        <img src="https://cdn.magicpatterns.com/uploads/hF7rvjEq9antGAY8GqPuMH/Screenshot_2026-03-04_at_16.46.47.png" className="absolute inset-0 w-full h-full object-cover opacity-10" alt="" data-id="element-121" />
        <div className="absolute inset-0 bg-[#0B1623]/80" data-id="element-122" />
      </div>

      <div className="relative z-10 flex flex-col h-full" data-id="element-123">
        {/* Top bar: Back + Logo + Skip */}
        <div className="flex items-center justify-between mb-6" data-id="element-124">
          <button onClick={onBack} className="p-2 -ml-2 text-slate-500 hover:text-white transition-colors" aria-label="Go back" data-id="element-125">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-126" />
          </button>
          <div className="bg-white px-3 py-1.5 rounded-lg inline-block shadow-sm" data-id="element-127">
            <img src="https://cdn.magicpatterns.com/uploads/ifejLUcSApynCwwp5oN3Zr/Screenshot_2026-03-04_at_16.40.29.png" alt="Minerva Imaging" className="h-5 object-contain" data-id="element-128" />
          </div>
          <button onClick={onSkip} className="text-xs text-slate-500 hover:text-slate-300 transition-colors px-2" data-id="element-129">
            Skip
          </button>
        </div>

        <ProgressIndicator current={questionNum} total={totalQuestions} data-id="element-130" />

        <motion.h2 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-2xl md:text-3xl font-light text-white mb-12 leading-tight" data-id="element-131">
          {headline}
        </motion.h2>

        <div className="space-y-4 mt-auto mb-8" data-id="element-132">
          {options.map((option, index) => <motion.button key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2 + index * 0.1
        }} onClick={() => {
          setTimeout(() => onSelect(index), 300);
        }} className="w-full text-left p-5 rounded-xl border border-white/10 bg-white/5 backdrop-blur-sm hover:border-[#4B9FE1]/50 hover:bg-white/10 transition-all duration-200 group relative overflow-hidden focus:outline-none focus:ring-2 focus:ring-[#4B9FE1] focus:ring-offset-2 focus:ring-offset-[#0B1623]" data-id="element-133">
              <div className="absolute inset-0 bg-[#4B9FE1]/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" data-id="element-134" />
              <div className="relative flex items-start" data-id="element-135">
                <span className="flex-shrink-0 w-7 h-7 rounded-full border border-white/20 flex items-center justify-center text-xs font-medium text-slate-400 mr-4 group-hover:border-[#4B9FE1] group-hover:text-[#4B9FE1] group-hover:bg-[#4B9FE1]/10 transition-colors" data-id="element-136">
                  {String.fromCharCode(65 + index)}
                </span>
                <span className="text-slate-300 font-medium leading-snug group-hover:text-white transition-colors pt-1" data-id="element-137">
                  {option}
                </span>
              </div>
            </motion.button>)}
        </div>
      </div>
    </div>;
}